module.exports = __webpack_public_path__ + "static/media/stop-icon-blue.2dcd7329.svg";